/**
 * Action type to set Picture-in-Picture active state.
 */
export const SET_PIP_ACTIVE = 'SET_PIP_ACTIVE';
